import { Button, FormControl, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { fetchContent, saveContent } from '../../../utils/firebase/firebase.utils';

const EditContent: React.FC = () => {

    const [announcement, setAnnouncement] = useState<string>("");
    const [contentSaved, setContentSaved] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    function getAnnoucement() {
        const mainPage = fetchContent('mainPage');
        mainPage.then(content => {
            if (content) {
                setAnnouncement(content.announcement);
            }
        });
    }

    async function saveAnnoucement() {
        setIsSubmitting(true);
        const result = await saveContent('mainPage', announcement);
        if (result) {
            setContentSaved(true);
            setIsSubmitting(false);
            setTimeout(() => {
                setContentSaved(false);
            }, 3000);
        }
    }

    useEffect(() => {
        getAnnoucement();
    }, []);

    return (
        <React.Fragment>
            <h1>Content</h1>
            <FormControl sx={{ p: 1, width: "100%" }} variant="outlined">
                <TextField
                    sx={{ backgroundColor: 'white', mb: 2 }}
                    id="outlined-multiline-static"
                    label="Announcement"
                    multiline
                    rows={10}
                    value={announcement}
                    onChange={(e) => setAnnouncement(e.target.value)}
                />

                {contentSaved ? (
                    <Button
                        sx={{ width: "100px", margin: "0 auto" }}
                        variant="contained" endIcon={<CheckCircleIcon />}
                        size="small"
                        color="success"
                        title='Saved'
                    >
                        Saved!
                    </Button>
                ) : (
                    <Button
                        sx={{ width: "100px", margin: "0 auto" }}
                        variant="contained"
                        size="small"
                        onClick={saveAnnoucement}
                        color="primary"
                        title='Save'
                        disabled={isSubmitting}
                    >
                        Save
                    </Button>
                )
                }
            </FormControl>
        </React.Fragment>
    );
};

export default EditContent;